var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.5C0 0.672656 0.672656 0 1.5 0H6.75C7.57734 0 8.25 0.672656 8.25 1.5V10.5C8.25 11.3273 7.57734 12 6.75 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5ZM3 10.5C3 10.7063 3.16875 10.875 3.375 10.875H4.875C5.08125 10.875 5.25 10.7063 5.25 10.5C5.25 10.2937 5.08125 10.125 4.875 10.125H3.375C3.16875 10.125 3 10.2937 3 10.5ZM6.75 1.5H1.5V9H6.75V1.5Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHp);
export default __webpack_public_path__ + "static/media/hp.4b85f3776554a4e008ff34cd505e43d3.svg";
export { ForwardRef as ReactComponent };